/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* Slideshow fix */

const slideshows = document.querySelectorAll("[data-section-type='slideshow-section']");
slideshows.forEach((slideshow) => {
  setInterval( function() {
    const slide = slideshow.querySelector('.slideshow__slide--active');
    slide.classList.remove('slideshow__slide--active');

    const slides = $(slideshow).find('.slideshow__slide');
    var currentIndex = (slides.index(slide) + 1) % slides.length;

    slides[currentIndex].classList.add('slideshow__slide--active');

  }, 5000);
});



/* Marquee */

const marquees = document.querySelector('.marquee3k')

async function initMarquees () {
  setTimeout(function () {
    Marquee3k.init()
  }, 1000)

}


//DARK BG HEADER CHANGE

const darkBgs = document.querySelectorAll(".red-bg");
const headerElement = document.querySelector(".site-header");

document.addEventListener('scroll', function(e) {
  darkBgs.forEach((darkBG) => {
    if(isInViewport(darkBG)) {
      headerElement.style.color = "black"
      headerElement.style.filter = "invert(1)"
    } else {
      headerElement.style.color = "#ee562b"
      headerElement.style.filter = "invert(0)"
    }
  });
});

function isInViewport(ele) {
  const { top, bottom } = ele.getBoundingClientRect();
  const vHeight = ele.clientHeight;
  return (
    (top < 5 && top > -vHeight)
  );
}


/*LOGO SCROLL */

var logo = $(".site-logo-index"), 
    logoWidth = logo.width(), 
    scrollTo = window.innerHeight;

function getLogo() {
  var yPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0,
      yPer = (yPos / scrollTo); 

  if (yPer > 1) {
    yPer = 1;
  }

  if (window.innerWidth <= 750) {
    var bigWidth = (window.innerWidth / 100) * 90, 
        bigHeight = (bigWidth / 4.6) / 2;
  }

  if (window.innerWidth > 750) {
    var bigWidth = (window.innerWidth / 100) * 70, 
        bigHeight = (bigWidth / 4.6) / 2;
  }

  var logoSize = ((logoWidth*yPer)-(bigWidth*yPer)+bigWidth), 
      logoPos = ( -1*(yPer * (scrollTo / 2 - bigHeight )) + (scrollTo / 2 - bigHeight ) );

  logo.css({
    opacity: "1",
    transform: "translate3d(0," + logoPos + "px,0)",
    width: logoSize
  });
}


document.addEventListener('DOMContentLoaded', (event) => {
  document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
  if (logo) getLogo();
  if (marquees) initMarquees();
})

window.addEventListener('resize', function() {
  if (window.innerWidth >= 1000) {
    document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
  }
});

document.addEventListener('scroll', getLogo );



/* QTY */

$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 


/*ACCORDION */

var acc = document.getElementsByClassName("ingredient-title");
var panel = document.getElementsByClassName('ingredient-description');

for (var i = 0; i < acc.length; i++) {
  acc[i].onclick = function() {
    var setClasses = !this.classList.contains('active');
    setClass(acc, 'active', 'remove');
    setClass(panel, 'show', 'remove');

    if (setClasses) {
      this.classList.toggle("active");
      this.nextElementSibling.classList.toggle("show");
    }
  }
}

function setClass(els, className, fnName) {
  for (var i = 0; i < els.length; i++) {
    els[i].classList[fnName](className);
  }
}

/*PRODUCT CAROUSEL */


if (window.innerWidth <= 750) {
  const mySiema = new Siema({
    perPage: 1
  });
}


/*CART COUNT */
